import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

// =====================================================
// FIREBASE — PUSH NOTIFICATIONS + ANALYTICS ONLY
//
// ⚠️ FIREBASE AUTHENTICATION IS NO LONGER USED BY THIS APP.
//
// Authentication (registration, email verification, login, password reset and
// the bank-details email check) moved to our own backend with Resend OTP. That
// is why `getAuth` and the `auth` export that used to live here are gone — not
// an oversight, and not something to add back "just in case": a live Firebase
// Auth instance would be a second, unenforced identity for the same account.
//
// WHAT FIREBASE STILL DOES HERE, UNCHANGED:
//   • Cloud Messaging (FCM) — push notifications. services/fcm.js imports the
//     `app` below and registers public/firebase-messaging-sw.js.
//   • Analytics.
// Both were explicitly out of scope for the auth migration and neither was
// touched by it.
// =====================================================

const firebaseConfig = {
  apiKey: "AIzaSyC16SzXkEf43YM0d97ngL2OpjD4cylXJzM",
  authDomain: "theblogssphere-f2b00.firebaseapp.com",
  projectId: "theblogssphere-f2b00",
  storageBucket: "theblogssphere-f2b00.appspot.com",
  messagingSenderId: "30280828138",
  appId: "1:30280828138:web:21f4603d0bb74c5964c393",
  measurementId: "G-TK02HBJDL8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ App instance — exported so the FCM messaging service (src/services/fcm.js)
// reuses this exact initialised app instead of creating a second one. There is
// only ONE initializeApp in the frontend, mirroring the single admin instance
// on the server. The same firebaseConfig is duplicated into
// public/firebase-messaging-sw.js because a service worker cannot import this
// ES module — that is required by FCM, not a second Firebase project.
export { app, firebaseConfig };

// ✅ Analytics (safe for SSR / production)
let analytics = null;
isSupported().then((yes) => {
  if (yes) analytics = getAnalytics(app);
});

export { analytics };
